import { createSlice } from '@reduxjs/toolkit'
import { getCookie } from 'utils/cookie'
import { RootState } from 'app/rootReducer'

export interface LocalStorage {
  [key: string]: string | null | undefined
}

export interface SessionStorage {
  [key: string]: string | null | undefined
}

export interface Cookies {
  [key: string]: string | null | undefined
}

export interface PersistedState {
  cookie: Cookies
  localStorage: LocalStorage
  sessionStorage: SessionStorage
}

const initialState: PersistedState = {
  cookie: getCookie(),
  localStorage: { ...window.localStorage },
  sessionStorage: { ...window.sessionStorage },
}

const persistedStateSlice = createSlice({
  name: 'persistedState',
  initialState,
  reducers: {
    reload(state) {
      state.cookie = getCookie()
    },
  },
})

export const { reload } = persistedStateSlice.actions

export default persistedStateSlice.reducer

export const persistedState = (state = initialState) => state

export const selectPersistedCookie = (state: RootState) => state.persistedState.cookie

export const selectPersistedLocalStorage = (state: RootState) => state.persistedState.localStorage

export const selectPersistedSessionStorage = (state: RootState) => state.persistedState.sessionStorage
